import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../../store';
import { deleteMethod, get, post, put } from '../../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  loggedInInspectionExamin: [],
  selectedInspectionExamin: [],
  currentInspectionExamin: [],
  documentTypes: [],
  documents: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'InspectionExaminExamin',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET InspectionExaminManagement
    getInspectionExaminSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET InspectionExaminManagement
    updateCurrentLoggedInInspectionExaminData(state, action) {
      state.loggedInInspectionExamin = action.payload;
    },

    // GET InspectionExaminManagement
    getCurrentInspectionExaminSuccess(state, action) {
      state.currentInspectionExamin = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    // GET InspectionExaminManagement
    getSpecificInspectionExaminDataSuccess(state, action) {
      state.selectedInspectionExamin = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    addOrUpdateInspectionExamins(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getInspectionExamin() {
  return async () => {
    try {
      const response = await get(`inspectionExamin`);
      if (response.status) {
        dispatch(slice.actions.getInspectionExaminSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInspectionExaminById(userId) {
  return async () => {
    try {
      const response = await get(`InspectionExaminById?userId=${userId}`);
      if (response.status) {
        dispatch(slice.actions.getInspectionExaminSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addInspectionExamin(body) {
  return async () => {
    try {
      const response = await post(`InspectionExamin`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionExamins(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateInspectionExamin(body) {
  return async () => {
    try {
      const response = await put(`InspectionExamin`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionExamins(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteInspectionExamin(body) {
  return async () => {
    try {
      const response = await deleteMethod(`InspectionExamin`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionExamins(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
